import cf from './cf';
import c60v from './c60v_20211024';

export default class c60v1a extends c60v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.d_viewDefs = {
      class: 'c60v1a',
      name: '休館日一覧',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
